import { render, staticRenderFns } from "./redbookPeople.vue?vue&type=template&id=b80ee2f2"
import script from "./redbookPeople.vue?vue&type=script&lang=js"
export * from "./redbookPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports